import api from "./api";

function base64ToUint8Array(base64String) {
    const padding = "=".repeat((4 - (base64String.length % 4)) % 4);
    const base64 = (base64String + padding).replace(/-/g, "+").replace(/_/g, "/");
    const raw = window.atob(base64);
    return Uint8Array.from([...raw].map((c) => c.charCodeAt(0)));
}

// Registers the service worker, requests permission and stores the subscription.
export async function enablePush() {
    if (!("serviceWorker" in navigator) || !("PushManager" in window)) {
        throw new Error("Este navegador não suporta notificações push.");
    }
    const permission = await Notification.requestPermission();
    if (permission !== "granted") throw new Error("Permissão de notificação negada.");

    const registration = await navigator.serviceWorker.register("/push-sw.js");
    await navigator.serviceWorker.ready;

    const { data } = await api.get("/push/public-key");
    let subscription = await registration.pushManager.getSubscription();
    if (!subscription) {
        try {
            subscription = await registration.pushManager.subscribe({
                userVisibleOnly: true,
                applicationServerKey: base64ToUint8Array(data.publicKey),
            });
        } catch (err) {
            throw new Error("Não foi possível ativar o push neste navegador. Tente fora do modo anônimo ou em outro navegador.");
        }
    }
    const json = subscription.toJSON();
    await api.post("/push/subscribe", { endpoint: json.endpoint, keys: json.keys });
    return true;
}
